import { Show, StackProps, VStack } from '@chakra-ui/react';

export type DesktopViewProps = StackProps;

export const DesktopView = (props: DesktopViewProps) => {
  return (
    <Show above="md" ssr>
      <VStack
        bg="dynamic.highlight"
        align="flex-end"
        justify="flex-start"
        shadow="0 0 1.25rem #00000065"
        pt="16.5rem"
        pr="2.5rem"
        {...props}
      />
    </Show>
  );
};
